module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carouselModule"
  }, [(_vm.images.length === 0) ? _c('div', [_c('div', {
    staticClass: "imagePlaceholder"
  })]) : _vm._e(), _vm._v(" "), (_vm.images.length) ? _c('div', {
    staticClass: "carousel slide carousel-fade z-depth-1",
    attrs: {
      "id": "carousel-activity-1",
      "data-ride": "carousel",
      "data-interval": _vm.interval
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('li', {
      class: {
        active: _vm.isActive(index)
      },
      attrs: {
        "data-target": "#carousel-example-1",
        "data-slide-to": "index"
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      staticClass: "carousel-item",
      class: {
        active: _vm.isActive(index)
      }
    }, [_c('div', {
      staticClass: "image",
      style: ({
        backgroundImage: 'url(' + image.large_path + ')'
      })
    })])
  })), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#carousel-activity-1",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "icon-prev",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#carousel-activity-1",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "icon-next",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a20432a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a20432a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = 778
// module chunks = 3